/* eslint-disable */
import store from "@/store";
import base from "@/config/base";
import * as XLSX from 'xlsx';
import api_provider from '../providers/api_provider';
import urls_server from '../config/urls_server';
import Avatar from '@/assets/img/avatars/user.jpg';
import securedWebStorage from '@/main';
import * as turf from '@turf/turf';
import Swal from "sweetalert2";

export default {

    // Iniciales (hasta 2) a partir de un nombre, para avatares.
    initials(name) {
        if (!name) return "?";
        return name
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map((w) => w.charAt(0).toUpperCase())
            .join("");
    },

    // Extrae el mensaje de error controlado del backend desde un error de axios.
    // El BFF reenvía los no-200 como HTTPException -> { detail: <texto> }, donde
    // detail suele ser el body crudo de Django (string JSON: '{"error":"..."}').
    getBackendError(error) {
        const data = error?.response?.data;
        if (!data) return null;
        let detail = data.detail !== undefined ? data.detail : data;
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch (e) {
                return detail; // texto plano
            }
        }
        return (detail && detail.error) || null;
    },

    // Muestra en una alerta el error controlado del backend; si no lo hay (una caída de
    // red, por ejemplo), lo deja en la consola con `context` para ubicarlo.
    showBackendError(error, title, context) {
        const msg = this.getBackendError(error);
        if (msg) Swal.fire(title, msg, "error");
        else console.log(`Error ${context}: `, error);
    },

    // Fecha y hora locales de un valor ISO, o "" si no hay valor.
    formatDateTime(value) {
        return value ? new Date(value).toLocaleString() : "";
    },

     // Obtener llos nombres de los registros de postgres por id
    async get_name_back(entity, id){
        // console.log(entity, id)
        try {
            if(id){
                let postData = {
                    entity: entity,
                    id: id,
                }
                const response = await api_provider.post(urls_server.get_name_by_id, postData)
                if (response && response.data) {
                    if (response.data.name) {
                        return response.data.name
                    }
                }
                return []
            }
            return []
        } catch (error) {
            console.log("Error get_zone_list: ", error);
        }
    },
    // Obtener las zonas por empresa del usuario
    async get_rules_types_config(){
        try {
            const response = await api_provider.post_bff_fastapi('/rules/rules_types', {}, "get")
            if (response.data) {
                // console.log('response:', response.data)
                const data = response.data.data;
                if (data) {
                    // console.log("data", data)
                    return data
                }
            }
            return []
        } catch (error) {
            console.log("Error get_zone_list: ", error);
        }
    },
    // Obtener las zonas por empresa del usuario
    async get_zones(){
        var companyFilter = securedWebStorage.getItem("id_company")
        const system_role = securedWebStorage.getItem("role")
        const user_id = securedWebStorage.getItem("id")
        if( system_role == 'WISETRACK_ADMIN'){
            companyFilter = ""
        }

        const id_client = null;
        const url = `/zones/?page=${0}&limit=${0}&sortText=${"_id"}&sortDir=${"asc"}&filterText=${""}&company=${companyFilter}&client=${id_client}&user_id=${user_id}`;
        try {
            const response = await api_provider.post_bff_fastapi(url, {}, "get")
            // console.log("response", response)
            if (response.data) {
                const data = response.data.data;
                // console.log('response:', response.data)
                if (data) {
                    return data.zones
                }
            }
            return []
        } catch (error) {
            console.log("Error get_zone_list: ", error);

        }
    },
    // obteneer fecha desde ISO a formato dd/mm/aaaa
    getDate(date_text) {
        if (date_text) {
            const date = new Date(date_text);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } else {
            return '-';
        }
    },
    // obteneer fecha desde ISO a formato hh:mm hrs
    getHour(date_text) {
        if (date_text) {
            const date = new Date(date_text);
            return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} hrs`;
        } else {
            return '-';
        }
    },
    // obteneer fecha desde ISO a formato dd/mm/aaaa hh:mm hrs
    getFullDate(date_text, withSeconds = false) {
        if (date_text) {
            const date = new Date(date_text);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = withSeconds ? `:${date.getSeconds().toString().padStart(2, '0')}` : '';
            return `${day}/${month}/${year} ${hours}:${minutes}${seconds} hrs`;
        } else {
            return '-';
        }
    },
    // Parcear la ruta de una imagen
    parseValidUrl(url) {
        let responseUrl = "";
        if (/^(f|ht)tps?:\/\//i.test(url)) {
            responseUrl = url;
        }else {
            responseUrl = `${base.config.BASE_URL}${url}`
        }
        // console.log("responseUrl: ", responseUrl)
        return responseUrl;
    },
    // recortar un texto
    shortenString(str, maxLength) {
        if (str && str.length > maxLength) {
            return str.slice(0, maxLength) + '...';
        }
        return str;
    },
    // recortar un texto considerando dimenciones
    shortenStringW(str) {
        let maxLength;
        const windowWidth = window.innerWidth;

        if (windowWidth >= 1700) {
            maxLength = 35;
        } else if (windowWidth >= 1600) {
            maxLength = 25;
        } else if (windowWidth >= 1500) {
            maxLength = 20;
        } else if (windowWidth < 1500) {
            maxLength = 15;
        }

        if (str && str.length > maxLength) {
            return str.slice(0, maxLength) + '...';
        }
        return str;
    },
    // PAra obtener el nombre segun el tipo de de regla
    getTypeName(type) {
        switch (type) {
            case 1:
                return 'Velocidad';
            case 2:
                return 'Zona prohibida';
            case 3:
                return 'Zona obligatoria';
            case 4:
                return 'Salida de zona';
            case 5:
                return 'Detención';
            case 6:
                return 'Sin señal';
            case 7:
                return 'Movimiento';
            case 8:
                return 'Sobreestadía';
            case 9:
                return 'Mantenimiento';
            default:
                return 'Desconocido';
        }
    },
    // pone la imagen por defecto de usuario en caso de no cargar
    onImageError(event) {
        event.target.src = Avatar;
    },
    // Formato de miles es-CL. Devuelve el valor tal cual si no es numérico, para
    // que un "—" o un texto pasen sin convertirse en "NaN".
    formatNumber(value) {
        if (value === null || value === undefined || value === "") return "0";
        const num = Number(value);
        // Un valor no numérico (por ejemplo el "—" de una caluga sin dato) pasa tal
        // cual en vez de convertirse en "NaN".
        return Number.isNaN(num) ? value : Intl.NumberFormat("es-CL").format(num);
    },
    // Darle formato a la fecha
    formatDate(dateString) {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        const formattedDate = new Date(dateString).toLocaleDateString('es-ES', options);
        return formattedDate;
    },
    // Exporta un listado a Excel: opcionalmente renombra columnas con el mapeo headers
    exportListExcel(dataFile, name, colWidth=300, headers=null) {
        try {
            // Si se pasa un mapeo de cabeceras, filtrar y renombrar columnas
            let exportData = dataFile;
            if (headers && Object.keys(headers).length > 0) {
                exportData = dataFile.map(row => {
                    const newRow = {};
                    for (const [key, label] of Object.entries(headers)) {
                        newRow[label] = row[key] !== undefined ? row[key] : '';
                    }
                    return newRow;
                });
            }

            // Genera el archivo Excel
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(exportData);

            // Define ancho de columnas
            const columnWidth = { wpx: colWidth };
            const columnCount = XLSX.utils.decode_range(ws['!ref']).e.c + 1;
            const columnWidths = Array(columnCount).fill(columnWidth);

            // usados en el caso de excel de listado control tag
            const firstRow = Object.keys(exportData[0]);
            const dateStartIndex = firstRow.indexOf(headers ? (headers['fecha_entrada'] || 'fecha_entrada') : 'fecha_entrada');
            const dateEndIndex = firstRow.indexOf(headers ? (headers['fecha_salida'] || 'fecha_salida') : 'fecha_salida');
            const highwayIndex = firstRow.indexOf(headers ? (headers['autopista'] || 'autopista') : 'autopista');
            const porchIndex = firstRow.indexOf(headers ? (headers['portico'] || 'portico') : 'portico');
            const choreIndex = firstRow.indexOf(headers ? (headers['flota'] || 'flota') : 'flota');
            if (dateStartIndex !== -1) { columnWidths[dateStartIndex] = { wpx: 150 };}
            if (dateEndIndex !== -1) { columnWidths[dateEndIndex] = { wpx: 150 };}
            if (highwayIndex !== -1) { columnWidths[highwayIndex] = { wpx: 200 };}
            if (porchIndex !== -1) { columnWidths[porchIndex] = { wpx: 400 };}
            if (choreIndex !== -1) { columnWidths[choreIndex] = { wpx: 300 };}

            ws['!cols'] = columnWidths;

            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });

            // Descarga el archivo Excel
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            this.triggerBlobDownload(blob, name);
            console.log("Exportación completada exitosamente.");
            return true;
        } catch (error) {
            console.log("Error exportListExcel: ", error);
            return false;
        }
    },
    // Exporta una lista de objetos a un archivo de texto delimitado (csv / txt)
    exportJsonToDelimited(data, fileName, { delimiter = ";", withHeaders = true, mimeType = "text/plain" } = {}) {
        if (!data || !data.length) return;
        const headers = Object.keys(data[0]);
        const buildLine = (values) => values
            .map((value) => `"${String(value ?? "").replace(/"/g, '""')}"`)
            .join(delimiter);
        const rows = data.map((row) => buildLine(headers.map((header) => row[header])));
        const content = (withHeaders ? [buildLine(headers), ...rows] : rows).join("\n");
        // Excel en Windows ignora el charset del MIME: sin BOM las cabeceras acentuadas
        // ("Compañía", "Teléfono") se abren con caracteres corruptos.
        const bom = mimeType === "text/csv" ? "\uFEFF" : "";
        this.triggerBlobDownload(new Blob([bom + content], { type: `${mimeType};charset=utf-8;` }), fileName);
    },
    // Descarga una lista de objetos en el formato elegido en VsudDownloadSelect
    downloadJsonAs(type, data, baseName) {
        if (type === "excel") {
            return this.exportListExcel(data, `${baseName}.xlsx`, 180);
        }
        if (type === "csv") {
            return this.exportJsonToDelimited(data, `${baseName}.csv`, { mimeType: "text/csv" });
        }
        return this.exportJsonToDelimited(data, `${baseName}.txt`);
    },
    // Descarga un Blob/arreglo de bytes como archivo
    triggerBlobDownload(data, filename) {
        const blob = data instanceof Blob ? data : new Blob([data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
    // Devuelve el estado del motor según la ignición y la velocidad.
    getEngineState(ignition, velocity) {
        if (velocity > 0 && ignition === null || ignition === true) return "Encendido";
        if (ignition === false) return "Apagado";
        return "Sin información";
    },
    // Escapa caracteres reservados de XML para uso en KML/XML
    escapeXml(value) {
        if (value === null || value === undefined) return "";
        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
    },
    // Construye un KML a partir de puntos [{ latitude, longitude, name, description }].
    // Genera una línea de recorrido (opcional) y un placemark por punto.
    buildKml(points, { documentName = "Recorrido", lineName = "Recorrido", includeLine = true } = {}) {
        const validPoints = (points || []).filter(p => p.latitude != null && p.longitude != null);
        const coord = p => `${String(p.longitude).replace(',', '.')},${String(p.latitude).replace(',', '.')}`;

        const line = includeLine && validPoints.length > 1
            ? `    <Placemark>
            <name>${this.escapeXml(lineName)}</name>
            <LineString>
                <tessellate>1</tessellate>
                <coordinates>${validPoints.map(coord).join(' ')}</coordinates>
            </LineString>
            </Placemark>\n`
                    : "";

        const placemarks = validPoints.map(p => `    <Placemark>
            <name>${this.escapeXml(p.name ?? "")}</name>
            <description>${this.escapeXml(p.description ?? "")}</description>
            <Point><coordinates>${coord(p)}</coordinates></Point>
            </Placemark>`).join('\n');

        return `<?xml version="1.0" encoding="UTF-8"?>
            <kml xmlns="http://www.opengis.net/kml/2.2">
            <Document>
                <name>${this.escapeXml(documentName)}</name>
            ${line}${placemarks}
            </Document>
            </kml>`;
    },
    // Construye y descarga un KML a partir de puntos
    downloadKml(points, filename, options = {}) {
        const kml = this.buildKml(points, options);
        const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
        this.triggerBlobDownload(blob, filename);
    },
    // Mensaje de error general de formulario
    showAlertResult(type, is_created) {
        var action_text = is_created ? "creado" : "actualizado";

        if(type == "success"){
            return "El registro se ha " + action_text + " correctamente";
        }else if (type == "warning"){
            return "El registro no ha podido ser guardado correctamente, revise los datos ingresados";
        }else if (type == "danger"){
            return "Es necesario completar los campos obligatorios solicitados, revise el formulario";
        }

    },
    // Distancia en metros
    distance_lat_long(lat1, lon1, lat2, lon2) {
      const radioTierra = 6371; // Radio medio de la Tierra en kilómetros

      // Convertir las coordenadas de grados a radianes
      const radianesLat1 = toRadians(lat1);
      const radianesLon1 = toRadians(lon1);
      const radianesLat2 = toRadians(lat2);
      const radianesLon2 = toRadians(lon2);

      // Diferencia de latitud y longitud
      const difLat = radianesLat2 - radianesLat1;
      const difLon = radianesLon2 - radianesLon1;

      // Fórmula de Haversine
      const a =
        Math.sin(difLat / 2) * Math.sin(difLat / 2) +
        Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(difLon / 2) * Math.sin(difLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      // Distancia en kilómetros
      const distanciaKm = radioTierra * c;

      // Convertir la distancia a metros
      const distanciaMetros = distanciaKm * 1000;

      return distanciaMetros;
    },
    // Distancia en kilometros
    calculateDistance(lat1, lon1, lat2, lon2) {
      const earthRadius = 6371000; // Radio de la Tierra en metros
      const dLat = toRadians(lat2 - lat1);
      const dLon = toRadians(lon2 - lon1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = earthRadius * c;

      return distance;
    },
    toRadians(grados) {
      return grados * (Math.PI / 180);
    },
    pointInPolygon(point, polygon) {
        var x = point[0], y = point[1];
        var inside = false;
        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i][0], yi = polygon[i][1];
            var xj = polygon[j][0], yj = polygon[j][1];

            var intersecta = ((yi > y) !== (yj > y)) &&
                             (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersecta) inside = !inside;
        }
        return inside;
    },
    pointInLine(point_coordinates, line) {
        const linestring1 = turf.lineString(line.coordinates);

        const bufferedPolygon = turf.buffer(linestring1, 20, {
            units: 'meters'
        });

        const point = turf.point(point_coordinates);
        const isWithinBuffer = turf.booleanPointInPolygon(point, bufferedPolygon);

        return isWithinBuffer;
    },
    pointInMultiPolygon(point, multiPolygon) {
        for(const polygon of multiPolygon){
          if(pointInPolygon(point, polygon)){
            return true;
          }
        }

        return false;
    },
    normalizeMassiveVinInput(rawInput) {
      if (!rawInput || rawInput.length === 0) return "";

      // 1) Limpieza: mayúsculas + separadores a espacio
      const cleaned = rawInput
        .toUpperCase()
        .replace(/[\n,;.\t/_-]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      // 2) Tokeniza solo alfanumérico (evita unir palabras distintas por error)
      const tokens = cleaned.match(/[A-Z0-9]+/g) || [];

      // 3) Validador VIN: 17 chars, A-Z/0-9, excluye I,O,Q
      const isValidVin = (vin) => /^[A-HJ-NPR-Z0-9]{17}$/.test(vin);

      const seen = new Set();
      const out = [];

      // Caso A: tokens ya vienen completos (17)
      for (const t of tokens) {
        if (t.length === 17 && isValidVin(t) && !seen.has(t)) {
          seen.add(t);
          out.push(t);
        }
      }

      // Caso B: VIN partido en varios tokens (ej: "LJD0 AA29 AS0320253")
      // Combina ventanas de hasta 4 tokens (ajustable) y valida si suma 17
      for (let i = 0; i < tokens.length; i++) {
        let acc = "";
        for (let j = i; j < Math.min(i + 4, tokens.length); j++) {
          acc += tokens[j];
          if (acc.length === 17) {
            if (isValidVin(acc) && !seen.has(acc)) {
              seen.add(acc);
              out.push(acc);
            }
            break;
          }
          if (acc.length > 17) break;
        }
      }
      return out.join(",");
    },

    normalizeMassivePlatesInput(rawInput) {
      // Las preferencias guardadas pueden traerlo como lista ([]) en vez de texto
      const text = Array.isArray(rawInput) ? rawInput.join(",") : rawInput;
      if (!text) return "";

      // mayúsculas y reemplazo de separadores por espacio
      let cleaned = String(text).toUpperCase().replace(/[\n,;.\t\s]+/g, " ");

      // acepta AAAA-99 y también AAAA99 (se inserta guion)
      const matches = cleaned.match(/[A-Z]{4}-?\d{2}/g) || [];

      // normaliza a AAAA-99, elimina duplicados y junta con coma
      const normalized = [...new Set(
        matches.map(p => p.replace(/-/g, "").replace(/^([A-Z]{4})(\d{2})$/, "$1-$2"))
      )];

      return normalized.join(",");
    },
}